import { Pipe, PipeTransform } from '@angular/core';
import { i18nPipeTransform } from 'src/helpers/translationHelpers';

@Pipe({
  name: 'i18n',
})
export class I18nPipe implements PipeTransform {
  // date should come in db-day-date format (yyyy-MM-dd)
  transform(
    translationKey: string,
    replaceVariables?: { [key: string]: string | undefined | null | number },
  ) {
    return i18nPipeTransform(translationKey, replaceVariables);
  }
}
